import SecondaryButton from "components/buttons/SecondaryButton";
import {
  DetailsList,
  Item,
  Label,
  Value,
} from "components/detailsList/DetailsList";
import {
  ContentContainer,
  HeaderContainer,
  ShadowCard,
} from "components/ShadowCard";
import { Headline4 } from "components/typography/Headline4";
import { useState } from "react";
import { Separator } from "types/separator/separator.type";
import {
  FacilityType,
  getFacilityTypeValue,
  getWaterMeasurementLengthValue,
  getWaterMeasurementPointValue,
  getWaterMeasurementReportingUnitLabel,
  getWaterMeasurementVehicleTypeValue,
  getWaterMeterExistsLabel,
  WaterMeasurementPointData,
} from "types/separator/waterMeasurementPointData.type";
import { EditTechnicalInformationModal } from "./EditTechnicalInformationModal";

type Props = {
  separator: Separator;
};
export const ProvtagningspunktTechnicalInformation = ({ separator }: Props) => {
  const [isPatchModalOpen, setIsPatchModalOpen] = useState(false);

  return (
    <ShadowCard className="max-w-5xl">
      <HeaderContainer>
        <Headline4>Teknisk information</Headline4>
        <SecondaryButton
          size="small"
          onClick={() => {
            setIsPatchModalOpen(true);
          }}
        >
          Ändra
        </SecondaryButton>
      </HeaderContainer>
      <EditTechnicalInformationModal
        isOpen={isPatchModalOpen}
        onClose={() => setIsPatchModalOpen(false)}
        separatorId={separator.id}
        waterMeasurementPointData={
          separator.waterMeasurementPointData as WaterMeasurementPointData
        }
      />
      <ContentContainer>
        <DetailsList>
          <Item>
            <Label>Provtagningslängd</Label>
            <Value>
              {getWaterMeasurementLengthValue(
                separator.waterMeasurementPointData,
              )}
            </Value>
          </Item>
          <Item>
            <Label>Provtagningspunkt</Label>
            <Value>
              {getWaterMeasurementPointValue(
                separator.waterMeasurementPointData,
              )}
            </Value>
          </Item>
          <Item>
            <Label>Analyser</Label>
            <Value>{separator.waterMeasurementPointData?.analyses}</Value>
          </Item>
          <Item>
            <Label>Gränsvärden</Label>
            <Value>{separator.waterMeasurementPointData?.limits}</Value>
          </Item>

          <Item>
            <Label>Typ av verksamhet</Label>
            <Value>
              {getFacilityTypeValue(separator.waterMeasurementPointData)}
            </Value>
          </Item>
          {separator.waterMeasurementPointData?.facilityType ===
            FacilityType.VehicleWash && (
            <>
              <tr>
                <td colSpan={2} className="pb-1 pt-4 sm:pl-6">
                  <span className="text-xs font-semibold uppercase tracking-widest text-gray-800">
                    Fordonstvätt
                  </span>
                </td>
              </tr>
              <Item>
                <Label>Vattenmätare finns</Label>
                <Value>
                  {getWaterMeterExistsLabel(
                    separator.waterMeasurementPointData?.waterMeterExists,
                  )}
                </Value>
              </Item>
              <Item>
                <Label>Redovisning</Label>
                <Value>
                  {getWaterMeasurementReportingUnitLabel(
                    separator.waterMeasurementPointData?.reporting,
                  )}
                </Value>
              </Item>
              <Item>
                <Label>Fordonstyp</Label>
                <Value>
                  {getWaterMeasurementVehicleTypeValue(
                    separator.waterMeasurementPointData,
                  )}
                </Value>
              </Item>
            </>
          )}
        </DetailsList>
      </ContentContainer>
    </ShadowCard>
  );
};
